import template from './needsAnalysis.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    needsAnalysis: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, helperService, LevelOption) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = null;
      ctrl.availableNatureOfServiceSought = [];
      ctrl.availableLevelOptions = [];
      ctrl.availableYesNoOptionOne = [];
      ctrl.availableLocationOfAssetsOrFunds = [];
      ctrl.availableLeadSourcingMethod = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableNatureOfServiceSought = helperService.getAvailableNatureOfServiceSought();
        ctrl.availableLevelOptions = helperService.getAvailableLevelOptions();
        ctrl.availableYesNoOptionOne = helperService.getAvailableYesNoOptions({ option: 1 });
        ctrl.availableLocationOfAssetsOrFunds = helperService.getAvailableLocationOfAssetsOrFunds();
        ctrl.availableLeadSourcingMethod = helperService.getAvailableLeadSourcingMethod();
        ctrl.needsAnalysis = ctrl.needsAnalysis || {};
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isReady = true;
      };

      ctrl.getOverallRiskScore = () => {
        let overallRiskScore = 0;
        let countSelected = 0;
        if (ctrl.needsAnalysis && ctrl.needsAnalysis.risk) {
          Object.keys(ctrl.needsAnalysis.risk).forEach((key) => {
            const obj = ctrl.needsAnalysis.risk[key];
            Object.keys(obj).forEach((prop) => {
              if (prop === 'assessment') {
                switch (obj[prop]?.name) {
                  case LevelOption.low.name:
                    overallRiskScore += 1;
                    countSelected += 1;
                    break;
                  case LevelOption.medium.name:
                    overallRiskScore += 2;
                    countSelected += 1;
                    break;
                  case LevelOption.high.name:
                    overallRiskScore += 3;
                    countSelected += 1;
                    break;
                  default:
                    break;
                }
              }
            });
          });
        }
        const total =
          overallRiskScore > 0 && countSelected > 0
            ? helperService.round({ value: _.divide(overallRiskScore, countSelected) })
            : 0;
        if (total >= 0.5 && total < 1.5) {
          ctrl.needsAnalysis.risk.overallRiskScore = LevelOption.low;
        }
        if (total >= 1.5 && total < 2.5) {
          ctrl.needsAnalysis.risk.overallRiskScore = LevelOption.medium;
        }
        if (total >= 2.5) {
          ctrl.needsAnalysis.risk.overallRiskScore = LevelOption.high;
        }
        return ctrl.needsAnalysis?.risk?.overallRiskScore?.name !== LevelOption.none.name
          ? ctrl.needsAnalysis?.risk?.overallRiskScore?.title()
          : 'N/A';
      };

      ctrl.saveNeedsAnalysis = _.debounce(() => {
        ctrl.onFinished({ needsAnalysis: ctrl.needsAnalysis });
      }, 1500);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
